/**
 * Walidacja poprawności numeru PESEL
 */
import { isInvalidPeselNumber } from '../../../common/invalidDocumentNumbersConfig'

export const isPeselValid = {
  name: 'isPeselValid',
  message: 'Podaj 11-cyfrowy numer PESEL',
  test: (peselToCheck: string | undefined) => {
    if (!peselToCheck) {
      return false
    }

    if (isInvalidPeselNumber(peselToCheck)) {
      return false
    }

    const weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3]
    let sum = 0
    const controlNumber = parseInt(peselToCheck.substring(10, 11))

    for (let i = 0; i < weight.length; i++) {
      sum += parseInt(peselToCheck.substring(i, i + 1)) * weight[i]
    }

    sum = sum % 10
    const numbers = []

    for (let i = 0; i < 6; i++) {
      numbers[i] = Number.parseInt(peselToCheck[i])
    }

    const month = (numbers[2] % 2) * 10 + numbers[3]
    const day = numbers[4] * 10 + numbers[5]

    if (month === 0 || day === 0) {
      return false
    }

    return (10 - sum) % 10 === controlNumber
  }
}
